// extracted by mini-css-extract-plugin
export default {"menuItem":"mfr-a4p1y5hr","startIcon":"mfr-oJH6_hXy","menuItemText":"mfr-JwREdN8u","endIcon":"mfr-eoHAxUVQ"};